import { TableRow as HeroUiTableRow } from '@heroui/table';

export const TableRow = HeroUiTableRow;
